import { MainHeading, css } from '@sitewerk/juraholzbau-design-system'
import React from 'react'
import { ContentGridItem } from '../lib/sanity-types'
import { ContentGrid, transformForGrid } from './content-grid'

export type RelatedProps = {
  items?: ContentGridItem[]
}

export const Related: React.FC<RelatedProps> = ({ items }) => {
  return (
    <div
      css={css((theme: any) => ({
        background: theme.colors.white,
        borderTop: `1px solid ${theme.colors.whiteTransparent[100]}`
      }))}
    >
      <ContentGrid
        text={{
          title: 'Das könnte Sie auch noch interessieren',
          description: null
        }}
        items={transformForGrid(items)}
      />
    </div>
  )
}
